import React from 'react';
import { RegularButton, Typography } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { controlStyles, SeeMoreCardStyles, sponsoredSeeMoreCardStylesMedia, SeeMoreCaption } from './styles';
import { useTranslation } from 'react-i18next';

type SeeMoreButtonProps = {
  isSponsored?: boolean;
  seeAllButtonCaption: string;
  seeMoreLinkActual: string;
  seeMoreLinkOnClickHandler: () => void;
};

export const SeeMoreButton: React.FC<SeeMoreButtonProps> = ({
  isSponsored = false,
  seeAllButtonCaption,
  seeMoreLinkActual,
  seeMoreLinkOnClickHandler,
}) => {
  const { t } = useTranslation();
  return (
    <SeeMoreCardStyles
      isSponsored={isSponsored}
      href={seeMoreLinkActual}
      onClick={seeMoreLinkOnClickHandler}
      className={sponsoredSeeMoreCardStylesMedia}
    >
      <RegularButton
        className={controlStyles}
        aria-label={t('ui.aria-label.see-all')}
        iconOnly
        rounded
        invert
        size="l"
        variant="primary"
      >
        <ChevronRightIcon type="outline" size="l" color="text-primary" />
      </RegularButton>
      <SeeMoreCaption isSponsored={isSponsored}>
        <Typography variant="m" size="body_short" color="text-primary">
          {seeAllButtonCaption}
        </Typography>
      </SeeMoreCaption>
    </SeeMoreCardStyles>
  );
};
